import { Form, Radio } from "antd";
import styled from "styled-components";

import CustomModal from "@/components/CustomModal";
import FormItem from "@/components/FormItem";
import { Text, Title } from "@/components/Typography";
import breakpoints from "@/constants/breakpoints";

export const ModalStyled = styled(CustomModal)`
    min-width: 900px;

    .ant-modal-body {
        min-height: 521px;
        padding: 20px 32px 0;
    }

    @media ${breakpoints.xs} {
        width: 100%;
        min-width: initial;
    }
`;

export const GridForm = styled(Form)`
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    column-gap: 64px;

    @media ${breakpoints.xs} {
        display: flex;
        flex-direction: column;
    }
`;

export const FormItemStyled = styled(FormItem) <{ $marginBottom?: number }>`
    width: 100%;
    margin-bottom: ${props => props.$marginBottom ? `${props.$marginBottom}px` : 0};
`;

export const FormItemGreenTariff = styled(FormItem)`
    margin-bottom: 4px;
`;

export const SectionHeader = styled(Title)`
    width: 100%;
    padding-bottom: 6px;
    margin-bottom: 20px;
    color: ${props => props.theme.features.administration.modalForm.sectionTitle.color} !important;
    border-bottom: 1px solid ${props => props.theme.features.administration.modalForm.sectionTitle.borderColor};
`;

export const FormItemTitleStyled = styled(Text)`
    min-width: 83px;
    margin-top: 8px;
    color: ${props => props.theme.features.administration.modalForm.sideTitleColor} !important;
`;

export const RadioGroupStyled = styled(Radio.Group)`
    display: flex;
    width: 100%;

    .ant-radio-button-wrapper-in-form-item {
        display: inline-flex;
        justify-content: center;
        width: 100%;
        text-wrap: nowrap;
    }

    @media ${breakpoints.xs} {
        flex-wrap: wrap;
    }
`;

export const MarginValueContainer = styled.div`
    display: flex;
    column-gap: 8px;
    width: 60%;
`;

export const AddonText = styled(Text)`
    color: ${props => props.theme.features.administration.modalForm.addonColor} !important;
`;
